module.exports = __webpack_public_path__ + "static/media/Pipes.9fb5c750.svg";